import {PlanCodes} from 'ApplicationEntry/models/PlanCodes';
import * as P from 'ApplicationEntry/models/PlanCodes';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum PlanCodesActionType {
  UPDATE_PLAN_CODE = 'planCodes/UPDATE_PLAN_CODE',
  REPLACE_PRODUCT = 'planCodes/REPLACE_PRODUCT',
}

export const isPlanCodesAction = (action: any): action is PlanCodesAction =>
  action.type in reverseEnum(PlanCodesActionType);

export const updatePlanCode = (index: number, units: number) =>
  createAction(PlanCodesActionType.UPDATE_PLAN_CODE, {index, units});
export const replaceProduct = (replace: boolean) => createAction(PlanCodesActionType.REPLACE_PRODUCT, {replace});

export type PlanCodesAction = ReturnType<typeof updatePlanCode> | ReturnType<typeof replaceProduct>;

type PlanCodesState = PlanCodes;

export default (state: PlanCodesState, action: PlanCodesAction) => {
  switch (action.type) {
    case PlanCodesActionType.UPDATE_PLAN_CODE:
      return P.updatePlanCode(action.payload.index, action.payload.units)(state);
    case PlanCodesActionType.REPLACE_PRODUCT:
      return P.updateProduct(action.payload.replace)(state);
    default:
      return state;
  }
};
